import { ConversationStarterPlatform } from "@prisma/postgresClient";

export default ConversationStarterPlatform;
